import type { SelectHTMLAttributes } from 'react';
import { Icon } from '@/components/foundations';

export type SelectOption = { value: string; label: string };
export type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> & {
  label: string;
  options: SelectOption[];
  /** Primeira opção vazia (rótulo do filtro). */
  placeholder?: string;
};

/**
 * Select nativo no visual do pacote (`.select` + chevron).
 * Provisório: o Dropdown/Select acessível do design system é a issue #7 e substitui este por dentro.
 */
export function Select({ label, options, placeholder, ...select }: SelectProps) {
  return (
    <div className="select">
      <select aria-label={label} {...select}>
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <Icon name="down" />
    </div>
  );
}
